import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, FormGroup, Input, Label, Modal, Row} from 'reactstrap';

import {INTERNATIONAL, LB_ACTIVE, LB_CODE} from "../../../../components/i18n/i18n";

import SelectGeneric from "../../../../components/select/selectGeneric";
import {placeProvider} from "../../../../providers/placeProvider";
import {
    FL_HORARIO_DURATION,
    FL_PLACE
} from "../../../../components/i18n/formLabels";
import {
    PH_CODE,
    PH_HORARIO_DURATION,
} from "../../../../components/i18n/placeHolders";
import Switch from "react-bootstrap-switch";
import {TT_CLOSE, TT_SAVE} from "../../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";
import {getCurrentDateForCodeField} from "../../../../util/DateTools";
import {hotelActivityService} from "../../../../jwt/_services/hotel/hotelActivityService";
import Separator from "../../../../components/Separator";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import ActivitySectionLangs from "./_langs";
import TranslateButton from "../../../../components/buttons/TranslateButton";
import ImagePicker from "../../../../components/imagePickerComponents/ImagePicker";
import {hotelActivityMediaService} from "../../../../jwt/_services/core/hotelActivityMediaService";
import Schedules from "../../activity/schedule/Schedules";

export const ActivitySectionForm = forwardRef((props, ref) => {
    const path = props.path;
    const [udn] = useState(props.udn || null);
    const [app] = useState(props.app || null);

    const [categoryId, setCategoryId] = useState(  null);
    const [duration, setDuration] = useState( null);
    const [code, setCode] = useState( null);
    const [placeId, setPlaceId] = useState( null);
    const [status, setStatus] = useState( true);
    const [langs, setLangs] = useState( []);
    const [translatableLangs, setTranslatableLangs] = useState( []);
    const [editMode, setEditMode] = useState(false);
    const [showOrder, setShowOrder] = useState(0);

    const [showModal, setShowModal] = useState(true);
    const modalRef = useRef(null);

    const [modal, setModal] = useState(false);
    const [item, setItem] = useState(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(item);
    }

    useImperativeHandle(ref, () => ({
        showModal(_item, _index, _category) {
            const autocode = `${udn?.code}_act_` + getCurrentDateForCodeField();

            setItem( _item );
            setEditMode( !!_item?.id );
            setCode(_item?.code || autocode.toUpperCase());
            setShowOrder( (_item?.showOrder || _index || 0) );
            setLangs(_item?.langs || []);
            setTranslatableLangs(_item?.translatedLangs || [])
            setStatus(_item?.id ? _item?.status : true );
            setCategoryId(_item?.category?.id || _category?.id || null);
            setPlaceId(_item?.place?.id || null);
            setDuration(_item?.duration || null);
            setModal(!modal);
        },
        updateData(_item, _category) {
            if (_item) {
                setItem( _item );
                setCode(_item?.code || '');
                setShowOrder( _item?.showOrder || 0 );
                setLangs(_item?.langs || []);
                setTranslatableLangs(_item?.translatedLangs || [])
                setStatus(_item?.id ? _item?.status : true );
                setCategoryId(_item?.category?.id || _category?.id || null);
                setPlaceId(_item?.place?.id || null);
                setDuration(_item?.duration || null);
            }
        },
    }));


    // ----------------------------------------------
    //            SUBMIT
    // ----------------------------------------------
    const onSubmit = (_) => {
        const dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            item: {
                code: code,
                showOrder: (showOrder + 1),
                duration: duration,
                udn : { id: udn?.id },
                status : status,
                langs: langs
            }
        }

        if(placeId != null)
            dataRequest.item.place = { id : placeId }

        if( categoryId != null )
            dataRequest.item.category = { id : categoryId }

        // console.log(dataRequest);
        // return;


        if (!editMode) {
            // console.log('save',  dataRequest);
            // return;
            genericIndexedActions.save(path, hotelActivityService, dataRequest)
        }
        else {
            let id = item.id;
            dataRequest.item.id = item?.id

            // console.log('update',  dataRequest);
            // return;
            genericIndexedActions.update(path, hotelActivityService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        setModal(!modal);
    }

    const refreshObject = () => {
        genericIndexedActions.get(path, hotelActivityService, item?.id, app?.fbDataBase?.id);
    }

    return (<>
        <Modal isOpen={modal} toggle={setModal} modalClassName="menu-modal-form-medium">
                <Card  className={'card-modal'}>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <>
                            <h2 className={'card-modal-title'} > { (udn?.value || '') + ' / ' + (item?.title || item?.name || '') }</h2>
                            <br />
                            <h5 className={'card-modal-uid'} > { '     uid: ' + (item?.uid || '') }</h5>
                        </>
                        <div className="top-right">
                            <GenericButton
                                style={'table'}
                                toolTip={TT_SAVE}
                                icon={'fa-save'}
                                permission={'add'}
                                onClick={onSubmit}
                            />
                            <GenericButton
                                style={'table'}
                                toolTip={'Actualizar datos'}
                                icon={'fa-refresh'}
                                permission={'search'}
                                onClick={refreshObject}
                            />
                            {
                                // editMode && userIsAdmin && <GenericButton
                                //     style={'table'}
                                //     toolTip={TT_HISTORY}
                                //     icon={'fa-clock'}
                                //     permission={'search'}
                                //     onClick={showHistory}
                                // />
                            }
                            <TranslateButton item={item} service={hotelActivityService}  askForConfirmation={false}/>
                            <Separator/>
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_CLOSE}
                                icon={'fa-times'}
                                permission={'search'}
                                onClick={closeForm}
                            />
                        </div>
                    </CardTitle>
                    <CardBody className={'card-body-modal'}>
                        <Row>
                            <Col md="6">
                                {item?.id &&
                                    <ImagePicker
                                        className={'hotelActivity'}
                                        title={'Actividad Media'}
                                        app={app}
                                        service={hotelActivityService}
                                        baseMediaService={hotelActivityMediaService}
                                        objectMedia={item}
                                        afterUpload={refreshObject}
                                    />
                                }
                            </Col>
                            <Col md="6">
                                <Row>
                                    {/*<Input*/}
                                    {/*    type="hidden"*/}
                                    {/*    name="code"*/}
                                    {/*    value={code}*/}
                                    {/*    onChange={e => setCode(e.target.value)}*/}
                                    {/*    placeholder={PH_CODE}*/}
                                    {/*    // className={(errors.code ? ' is-invalid' : '')}*/}
                                    {/*/>*/}
                                    <Col md="8">
                                        <FormGroup>
                                            <Label>{LB_CODE}</Label>
                                            <Input
                                                type="text"
                                                name="code"
                                                value={code || ''}
                                                onChange={e => setCode(e.target.value)}
                                                placeholder={PH_CODE}
                                                // className={(errors.code ? ' is-invalid' : '')}
                                            />
                                            {/*{ errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}*/}
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup>
                                            <Label>{FL_PLACE}</Label>
                                            <SelectGeneric
                                                initialValue={placeId}
                                                setExternalValue={value => setPlaceId(value)}
                                                isDisabled={false}
                                                provider={placeProvider}
                                                customFilter={{item: {udn: {id: udn?.id}}}}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="8">
                                        <FormGroup>
                                            <Label>{FL_HORARIO_DURATION}</Label>
                                            <Input
                                                type="text"
                                                name="duration"
                                                value={duration || ''}
                                                onChange={e => setDuration(e.target.value)}
                                                placeholder={PH_HORARIO_DURATION}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label>{LB_ACTIVE}</Label>
                                            <br/>
                                            <Switch
                                                animate={true}
                                                offText={"No"}
                                                onText={"Si"}
                                                value={status}
                                                onChange={() => setStatus(!status)}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                </Row>
                            </Col>
                        </Row>
                        <div className={'form-container'}>
                            <div className={''}>
                                <h2>{'Horarios'}</h2>
                            </div>
                            <div className={''}>
                                {
                                    editMode && <Row>
                                        <Col>
                                            <Schedules
                                                items={item?.schedules}
                                                path={path}
                                            />
                                        </Col>
                                    </Row>
                                }
                            </div>
                        </div>
                        <div className={'form-container'}>
                            <div className={''}>
                                <h2>{INTERNATIONAL}</h2>
                            </div>
                            <div className={''}>
                                <Row>
                                    <ActivitySectionLangs
                                        langs={langs}
                                        setLangs={setLangs}
                                        translatableLangs={translatableLangs}
                                    />
                                </Row>
                            </div>
                        </div>
                    </CardBody>
                    {
                        showModal && <LogHistoryModal
                            ref={modalRef}
                            item={item}
                        />
                    }
                </Card>
        </Modal>
        </>
    )
})
